/* eslint-disable */
import Vue from 'vue';
import Vuex from 'vuex';

import './registerServiceWorker';
import router from './router';
import { VueDiContainer } from 'vue-di-container';

// Plugins
import { i18n } from '@/plugins/i18n';
import vuetify from '@/plugins/vuetify';
import initializeApplication from '@/plugins/application-initialization';

// Components
import App from './views/app/app.component';
import NafathIdv from '@tawthiq/nafath-idv-vue';

// styles
import '../public/styles/main.scss';
import AxiosService from './services/axios';
import LoaderService from './services/loader';
import './directives';
import './validation';
import './filters';

Vue.config.productionTip = false;
Vue.config.devtools = process.env.NODE_ENV !== 'production';
Vue.use(VueDiContainer);
Vue.use(Vuex);
Vue.prototype.window = window;
Vue.use(NafathIdv);

declare global {
    interface Window {
        $config: any;
        $disableNewRequestsPeriod: any;
        ShowLoader(): void;
        HideLoader(): void;
    }
}

initializeApplication().then(() => {
    new Vue({

        i18n,
        router,
        vuetify,
        diProvide: [
            AxiosService,
            LoaderService,
        ],
        render: (h) => h(App),
    }).$mount('#app');
});
